export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  author: string;
  publishedAt: string;
  readTime: number;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '那年夏天，我在书店遇见了她',
    slug: 'na-nian-xiatian-shudian-yujian',
    excerpt: '有些相遇是命中注定的。那个闷热的午后，书店里淡淡的咖啡香，还有她低头翻书的侧脸——一切都像是电影里的画面，却真实地发生在我的生命里。',
    content: `<p>那是七月的第三个周末，天气闷热得让人透不过气。我躲进了街角那家熟悉的独立书店，空调的凉意和书香瞬间将我包围。</p>
<p>我习惯性地走向文学区，手指轻轻划过一排排书脊，直到目光停留在一本村上春树的旧版《挪威的森林》上。正准备伸手去拿，另一只手几乎同时触及了那本书。</p>
<p>"啊，不好意思。"我们几乎是异口同声。然后我们对视了，她微微笑了，眼睛弯成好看的弧度。我愣住了——不是因为尴尬，而是因为她笑起来的样子太美了，美得让我忘记了该说什么。</p>
<p>后来我们聊了很久，从村上春树聊到了三毛，从三毛聊到了各自的生活。她叫小念，是一名插画师，每周都会来这家书店寻找灵感。那天下午，时间仿佛被温柔地拉长了，直到书店打烊我们才依依不舍地分开。</p>
<p>现在回想起来，那可能是我人生中最美好的一次"意外"。因为那本书，那个对视，那个微笑，我的世界从此变得不同。我们已经在一起三年了，而故事，就是从那个夏天开始的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20meeting%20in%20a%20cozy%20bookstore%2C%20warm%20afternoon%20sunlight%20streaming%20through%20windows%2C%20bookshelves%20background%2C%20one%20reaching%20for%20a%20book%2C%20gentle%20eye%20contact%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20romantic%20atmosphere%2C%20artistic%20photography%2C%20shallow%20depth%20of%20field%2C%20feminine%20aesthetic%2C%20intimate%20moment&width=800&height=500&seq=article-cover-01&orientation=landscape',
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    author: '小鹿',
    publishedAt: '2026-08-05',
    readTime: 8,
    tags: ['相遇', '书店', '初恋', '回忆'],
    featured: true,
  },
  {
    id: 'art-002',
    title: '我们的周末日常：一起做饭的日子',
    slug: 'women-zhoumo-richang-yiqi-zuofan',
    excerpt: '周末的早晨，阳光透过窗帘洒进厨房。她系着围裙在煎蛋，我在旁边切水果。这就是我们最普通也最珍贵的日常——那些一起做饭、一起笑闹的时光。',
    content: `<p>如果你问我，恋爱中最幸福的时刻是什么？我不会说什么烛光晚餐或者旅行度假，我会告诉你是每个周末的早晨，我们在厨房里的那些时光。</p>
<p>她总是比我早起半小时。当我揉着眼睛走进厨房的时候，咖啡的香气已经在空气中弥漫开来。她系着那条我们一起挑的浅粉色围裙，正在认真地煎蛋——她煎蛋的时候会抿着嘴，特别专注，特别可爱。</p>
<p>"醒了？帮我拿下盘子。"她头也不回地说。我已经习惯了她的"指令"，乖乖地从碗柜里拿出两个盘子，然后开始洗水果。这是我们之间无声的默契——她负责热菜，我负责冷盘和摆盘。</p>
<p>有时候我会故意从背后抱住她，把下巴搁在她的肩膀上。"别闹，蛋要糊了。"她嘴上这么说，但身体会自然地往我这边靠。阳光从窗户斜斜地照进来，落在她的头发上，落在我们切好的水果上，落在这个平凡却充满爱的早晨。</p>
<p>这就是我们在一起的意义吧——不是轰轰烈烈的海誓山盟，而是每一个一起做饭、一起洗碗、一起窝在沙发上追剧的普通周末。这些日常碎片拼凑起来，就是我们爱情的模样。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20cooking%20together%20in%20a%20bright%20modern%20kitchen%2C%20morning%20sunlight%2C%20fresh%20vegetables%20and%20fruits%20on%20counter%2C%20one%20frying%20eggs%20one%20chopping%20fruits%2C%20warm%20cream%20and%20beige%20interior%2C%20cozy%20domestic%20scene%2C%20candid%20photography%20style%2C%20soft%20natural%20light%2C%20authentic%20happy%20moment&width=800&height=500&seq=article-cover-02&orientation=landscape',
    category: '日常生活',
    categorySlug: 'richang-shenghuo',
    author: '小鹿',
    publishedAt: '2026-08-03',
    readTime: 6,
    tags: ['做饭', '周末', '日常', '陪伴'],
    featured: true,
  },
  {
    id: 'art-003',
    title: '我们吵架了，但这次不一样',
    slug: 'women-chaojiale-danshi-buyiyang',
    excerpt: '再相爱的两个人也会有摩擦。但真正重要的不是避免争吵，而是学会如何在争吵之后，依然选择理解和拥抱对方。',
    content: `<p>我们吵架了。起因很小——她忘了告诉我今晚要加班，而我做了两个人的晚饭等了她两个小时。等她回来的时候，菜已经凉了，我的心也凉了半截。</p>
<p>"你怎么不提前说一声？"我的语气不太好。"我太忙了，忘了。"她的回答也很敷衍。然后就是你来我往的几句争执，声音越来越大，最后她摔门进了卧室，我坐在客厅的沙发上，眼泪不争气地流了下来。</p>
<p>过了大概二十分钟——这是我给自己设定的冷静时间——我深呼吸了几次，然后去敲了卧室的门。她打开门的时候眼眶也是红的。我们看着对方，谁也没说话，然后她先开口了："对不起，我应该提前告诉你。"</p>
<p>那一刻我突然意识到，我们和以前不一样了。以前吵架，我们会冷战好几天，谁也不肯先低头。但现在，我们都学会了先迈出那一步。不是因为谁对谁错，而是因为我们都知道，比起争个输赢，对方更重要。</p>
<p>"我也有不对的地方，我应该先给你打电话确认的。"我说。然后她抱住了我，很用力。那顿饭我们最后还是重新热了吃，虽然味道不如刚做好的，但我们吃得很开心。因为在那个拥抱里，我们又一次选择了彼此。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20sitting%20on%20a%20sofa%20facing%20each%20other%20in%20a%20dimly%20lit%20living%20room%2C%20warm%20table%20lamp%20glow%2C%20emotional%20moment%2C%20one%20reaching%20out%20to%20hold%20the%20other%20hand%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20intimate%20atmosphere%2C%20reconciliation%20scene%2C%20artistic%20composition%2C%20shallow%20depth%2C%20tender%20mood&width=800&height=500&seq=article-cover-03&orientation=landscape',
    category: '相处之道',
    categorySlug: 'xiangchu-zhidao',
    author: '安安',
    publishedAt: '2026-08-01',
    readTime: 7,
    tags: ['争吵', '沟通', '理解', '亲密关系'],
    featured: true,
  },
  {
    id: 'art-004',
    title: '写给二十岁的自己：你不必害怕',
    slug: 'xiegei-ershisui-ziji-bubi-haipa',
    excerpt: '二十岁那年，我第一次意识到自己可能喜欢女生。那种恐惧和迷茫至今记忆犹新。现在回头看，我想对当时的自己说：没关系，你只是爱上了一个人。',
    content: `<p>亲爱的二十岁的我：</p>
<p>我知道你现在很害怕。你躺在床上翻来覆去地睡不着，脑子里全是她的影子。你问自己："我怎么会喜欢上女生？这是正常的吗？别人会怎么看我？"</p>
<p>让我告诉你，这些问题，十年后的你都已经有了答案。</p>
<p>是的，你喜欢女生，这没有任何问题。那天在图书馆，你故意坐到了她对面，心跳快得像要跳出来——那不是"错误"，那是爱情最初的样子。你不需要为此道歉，不需要为此羞愧，更不需要把它藏起来。</p>
<p>你担心的那些眼光，确实存在，但没有你想象中那么可怕。真正爱你的人会接受全部的你，而那些不能接受的，他们的离开并不可惜。你最担心的妈妈，后来成了你最坚定的支持者——她花了一些时间去理解，但她说了一句话我一直记得："我只希望你幸福。"</p>
<p>所以二十岁的我啊，不要害怕。勇敢地去爱，去体验，去犯错，去成长。这条路也许不容易，但你的内心会越来越强大。十年后的你，有了相爱的伴侣，有了支持的朋友，有了坚定的自己。这一切，都源于当年那个勇敢认清自己的二十岁。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20sitting%20by%20a%20window%20writing%20in%20a%20journal%2C%20soft%20morning%20light%2C%20warm%20cream%20curtains%2C%20plants%20on%20windowsill%2C%20peaceful%20reflective%20atmosphere%2C%20feminine%20bedroom%20interior%2C%20nostalgic%20mood%2C%20soft%20focus%2C%20artistic%20photography%2C%20hope%20and%20self%20acceptance%20theme&width=800&height=500&seq=article-cover-04&orientation=landscape',
    category: '成长记录',
    categorySlug: 'chengzhang-jilu',
    author: '念念',
    publishedAt: '2026-07-28',
    readTime: 9,
    tags: ['自我接纳', '成长', '勇气', '出柜'],
    featured: false,
  },
  {
    id: 'art-005',
    title: '第一次和她一起旅行：在大理的风花雪月里',
    slug: 'diyici-yiqi-lvxing-dali',
    excerpt: '大理的洱海边，我们骑着单车穿行在金色的稻田之间。风吹起她的长发，她回头对我笑——那一刻，我觉得自己是世界上最幸运的人。',
    content: `<p>我们在一起半年后，决定来一次真正意义上的旅行。目的地选了很久，最后我们一致选了云南大理——因为她说她一直想去看苍山洱海。</p>
<p>飞机落地的那一刻，她兴奋得像个孩子，拉着我从机场一路小跑到租车的地方。我们在洱海边骑了一整天，从才村码头一直骑到喜洲古镇。风很大，把她的长发吹得乱七八糟，她笑了，我也笑了。</p>
<p>在喜洲的那天下午，我们找了一家安静的咖啡馆坐下。窗外是一大片金黄色的稻田，远山如黛，云层很低，阳光从云缝里漏下来，像舞台的聚光灯。她端着咖啡杯，眼睛望着窗外，忽然转头对我说："以后每年我们都要来一次新的地方，好不好？"</p>
<p>"好。"我回答得毫不犹豫。因为和她一起看世界的每一刻，都值得被定格。</p>
<p>晚上我们在古城的民宿天台上看星星。苍山沉默地立在夜色里，洱海的水声若有若无。她靠在我的肩膀上，轻声哼着一首我不知道名字的歌。那一刻我想，也许这就是所谓"风花雪月"吧——不是大理的四个景点，而是和她在一起的每一种天气、每一朵花、每一片雪、每一个月亮。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20riding%20bicycles%20along%20a%20scenic%20lake%20shore%2C%20golden%20rice%20fields%20background%2C%20distant%20mountains%2C%20sunset%20golden%20hour%20light%2C%20flowing%20hair%20in%20wind%2C%20happy%20expressions%2C%20travel%20adventure%2C%20Yunnan%20Dali%20vibe%2C%20warm%20golden%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20artistic%20travel%20photography&width=800&height=500&seq=article-cover-05&orientation=landscape',
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    author: '小鹿',
    publishedAt: '2026-07-26',
    readTime: 7,
    tags: ['旅行', '大理', '洱海', '浪漫'],
    featured: false,
  },
  {
    id: 'art-006',
    title: '她教会我的那些事：爱是动词',
    slug: 'ta-jiaohui-wo-ai-shi-dongci',
    excerpt: '在遇见她之前，我以为爱是一种感觉。遇见她之后我才明白，爱是每天早起泡的那杯蜂蜜水，是出门前叮嘱的"路上小心"，是无数个微小的行动。',
    content: `<p>我以前是个很"理论派"的人，总是纠结于"她爱不爱我"这个问题。我会分析她的每一条消息、每一个表情、每一次迟到的回复，然后得出一些连自己都不相信的结论。</p>
<p>直到和她在一起。</p>
<p>她很少说"我爱你"，但她会在每天早上我醒来之前，悄无声息地去厨房泡好一杯温度刚好的蜂蜜水放在我的床头。她知道我胃不好，每天都会在我包里放一小包苏打饼干。下雨天她会提前查好天气预报，把伞塞进我的包里。这些是我在"感觉"层面永远无法分析的证据。</p>
<p>有一天我问她："你为什么从来不说'我爱你'？"她愣了一下，然后很认真地说："我以为我一直在说。"</p>
<p>那一刻我才明白，对她来说，爱不是一个名词，不是一个状态，而是一个动词。它不是挂在嘴边的三个字，而是365天不缺席的蜂蜜水、是包里永远有的苏打饼干、是下雨天那把提前放好的伞。她用行动在说"我爱你"，每一天，每一个细节。</p>
<p>现在我也学会了用"动词"去爱。我不再纠结于那些虚无缥缈的"感觉"，而是用心去体会每一个真实的瞬间。谢谢你教会我，最深沉的爱，往往是最无声的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20morning%20bedroom%20scene%2C%20a%20cup%20of%20honey%20water%20on%20nightstand%2C%20soft%20sunlight%20through%20curtains%2C%20one%20woman%20sleeping%20peacefully%2C%20gentle%20morning%20atmosphere%2C%20cream%20and%20warm%20beige%20bedding%2C%20cozy%20intimate%20interior%2C%20quiet%20love%20gesture%2C%20minimalist%20feminine%20aesthetic%2C%20soft%20focus%2C%20tender%20care%20theme&width=800&height=500&seq=article-cover-06&orientation=landscape',
    category: '真实体验',
    categorySlug: 'zhenshi-tiyan',
    author: '小雨',
    publishedAt: '2026-07-22',
    readTime: 7,
    tags: ['爱的表达', '细节', '日常', '感悟'],
    featured: false,
  },
  {
    id: 'art-007',
    title: '跟我走吧：两个人的小窝装修记',
    slug: 'genwo-zouba-lianggeren-xiaowo',
    excerpt: '从找到房子到装修完毕，三个月的时间，我们把一个空荡荡的房间变成了属于我们的家。每一件家具、每一个角落，都有我们的故事。',
    content: `<p>这是我们在一起两年后做的最大的决定——一起租一套大一点的房子，然后把它装修成我们想要的样子。选房子的过程很有趣，我们在App上刷了无数套房源，周末就骑着共享单车满城跑去看房。</p>
<p>最后选定的那套在六楼，没有电梯，但推开窗能看到一大片法国梧桐。她站在空荡荡的客厅中央，转身对我说："就是这里了。"我点点头，因为我相信她的直觉。</p>
<p>接下来的三个月，我们几乎每个周末都泡在家居市场和建材城。为了一个沙发的颜色，我们争论了整整一个下午，最后选了两个人都不太满意但都能接受的亚麻色。为了书架的摆放方式，我们搬了三次。墙上的挂画是她画的，画的是我们第一次见面的那家书店。</p>
<p>最难忘的是搬家那天。我们两个女生搬了大大小小十几个箱子，累到瘫在还没铺床单的床垫上大口喘气。她忽然侧过身来看着我说："我们有自己的家了。"然后我们就在那个堆满箱子的房间里又哭又笑。</p>
<p>现在每次回家打开门，看到玄关处两双拖鞋整整齐齐地摆着，看到阳台上我们一起种的那盆薄荷，看到她窝在沙发上画画的样子——我就知道，这就是我想要的生活。不大，但每一寸都是我们的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20interior%20with%20warm%20natural%20light%2C%20two%20armchairs%20facing%20a%20window%20with%20trees%20outside%2C%20plants%2C%20bookshelf%2C%20art%20on%20wall%2C%20cream%20and%20beige%20color%20scheme%2C%20feminine%20home%20decor%2C%20two%20pairs%20of%20slippers%20by%20door%2C%20peaceful%20atmosphere%2C%20minimalist%20Nordic%20style%2C%20artistic%20interior%20photography&width=800&height=500&seq=article-cover-07&orientation=landscape',
    category: '日常生活',
    categorySlug: 'richang-shenghuo',
    author: '小鹿',
    publishedAt: '2026-07-19',
    readTime: 8,
    tags: ['装修', '家', '同居', '温馨'],
    featured: false,
  },
  {
    id: 'art-008',
    title: '如何向朋友介绍你的另一半',
    slug: 'ruhe-xiang-pengyou-jieshao-lingyiban',
    excerpt: '要不要告诉朋友？什么时候说？怎么说？这是每个女女情侣都会面临的问题。没有标准答案，但有一些温暖的思路可以分享。',
    content: `<p>"这是……我的朋友。"说这句话的时候，我的心紧了一下。</p>
<p>那是半年前的事了。我和她在一起刚三个月，几个大学好友约了聚会，她说想一起去。我犹豫了很久——该怎么介绍她？</p>
<p>那天聚会结束后，回家的地铁上，她一直沉默。快到家的时候她忽然说："如果你还不方便，以后我不去了。"她的语气很平静，但我知道她受伤了。不是因为我还没告诉朋友，而是因为我在介绍她的时候，用了"朋友"这个词——一个把她从我最亲近的人瞬间推远的词。</p>
<p>那天晚上我们聊了很久。她告诉我，她不要求我马上向全世界出柜，但她希望至少在亲近的朋友面前，她不需要假装。而我也坦诚了自己的恐惧——我怕失去朋友，怕被用异样的眼光看待。</p>
<p>后来我选择了最信任的闺蜜先坦白。当我鼓起勇气说出"其实她是我女朋友"的时候，闺蜜愣了一下，然后说："天哪，你们在一起多久了？快给我讲细节！"她的反应让我悬着的心落了地。原来我担心的那些可怕的场面，大多只存在于我的想象中。</p>
<p>现在我的经验是：选择一个你真正信任的人开始，用你舒服的方式说出来。不必大张旗鼓，也不必偷偷摸摸。真正的朋友，会在听完之后，像往常一样继续爱你。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20talking%20intimately%20at%20a%20cafe%20table%2C%20warm%20cafe%20interior%2C%20hands%20close%20to%20each%20other%20on%20table%2C%20serious%20but%20tender%20conversation%2C%20coffee%20cups%2C%20afternoon%20light%20through%20window%2C%20cream%20and%20warm%20brown%20tones%2C%20emotional%20support%20theme%2C%20artistic%20documentary%20style&width=800&height=500&seq=article-cover-08&orientation=landscape',
    category: '相处之道',
    categorySlug: 'xiangchu-zhidao',
    author: '安安',
    publishedAt: '2026-07-16',
    readTime: 8,
    tags: ['出柜', '朋友', '社交', '勇气'],
    featured: true,
  },
  {
    id: 'art-009',
    title: '异地恋的365天：距离让我们更近了',
    slug: 'yidilian-365tian-juli-gengjin',
    excerpt: '她去了另一个城市工作，我们开始了为期一年的异地恋。很多人不看好，但这一年的经历，反而让我们学会了更好的沟通和更深的信任。',
    content: `<p>当她说拿到上海那份offer的时候，我第一个反应是真心的开心——那是她梦寐以求的工作。然后，紧接而来的是一阵恐慌：上海和北京，1200公里的距离。</p>
<p>"我们可以试试。"她说。"我相信我们可以。"</p>
<p>于是我们开始了异地恋。刚开始的时候真的很不习惯。晚上回家，房间里空荡荡的。周末再也没人拉着我去逛菜市场。最难受的是遇到不开心的事，只能隔着屏幕打字，看不到她的表情，感受不到她的温度。</p>
<p>但我们慢慢找到了一套我们的相处方式。每天晚上九点，雷打不动的视频电话。我们发现了一个可以同步看电影的App，于是每周五晚上变成了我们的"云电影之夜"。她会在午休的时候给我点奶茶外卖，附言写着"替你喝了"。我会把每天发生的小事记在共享备忘录里，攒够一周发给她。</p>
<p>最神奇的是，距离反而让我们的沟通变深了。以前住在一起的时候，有些话觉得"反正天天见面"就懒得说。现在隔着屏幕，反而更愿意表达。我们聊童年、聊恐惧、聊对未来的想象——那些以前被日常琐事淹没的话题，现在都浮出了水面。</p>
<p>一年后她调回了北京。去机场接她的那天，远远看见她拖着行李箱走出来，我的心跳得像第一次约会一样。她抱上来的时候，我在她耳边说："欢迎回家。"这一年很辛苦，但也很值得。它让我们知道，有些距离，跨越了之后，心会贴得更近。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Woman%20looking%20at%20phone%20with%20warm%20smile%20in%20a%20cozy%20bedroom%20at%20night%2C%20soft%20lamp%20light%2C%20video%20call%20screen%20glow%2C%20long%20distance%20love%20theme%2C%20cream%20walls%2C%20half%20empty%20bed%2C%20emotional%20connection%20through%20technology%2C%20warm%20and%20slightly%20melancholic%20atmosphere%2C%20artistic%20photography%2C%20soft%20focus&width=800&height=500&seq=article-cover-09&orientation=landscape',
    category: '真实体验',
    categorySlug: 'zhenshi-tiyan',
    author: '小雨',
    publishedAt: '2026-07-13',
    readTime: 9,
    tags: ['异地恋', '信任', '沟通', '坚持'],
    featured: false,
  },
  {
    id: 'art-010',
    title: '深夜对话：我们聊了什么是"家"',
    slug: 'shenye-duihua-shenme-shi-jia',
    excerpt: '一个失眠的夜晚，我和她躺在床上，从天花板上的裂缝聊到了"家"的定义。那场深夜对话，让我对这段关系有了全新的理解。',
    content: `<p>那天晚上我失眠了，翻来覆去地睡不着。她被我吵醒了，迷迷糊糊地问："怎么了？"</p>
<p>"睡不着。"我说。</p>
<p>"那说说话吧。"她翻过身来面对着我，眼睛在黑暗中亮亮的。</p>
<p>不知道话题是怎么开始的，好像是从我嫌天花板那道裂缝太难看了起。她说她喜欢那道裂缝，"因为只有我们两个人知道它在那里。"这句话让我安静下来。然后我们开始聊什么才算是"家"。</p>
<p>她说她小时候觉得家是一个地址，是户口本上那个门牌号。后来觉得家是妈妈的饭香和爸爸看电视的声音。再后来一个人在外面租房，觉得家就是那个每个月要交租金的房间。</p>
<p>"但现在呢？"我问。</p>
<p>她沉默了一会儿，然后在黑暗中摸到了我的手，握住。"现在我觉得，家就是你在我旁边的感觉。不管你和我是在北京的这个房间，还是在某个陌生的城市、某个陌生的旅馆，只要你在我伸手就能碰到的地方——那里就是家。"</p>
<p>那一瞬间，我觉得天花板上的那道裂缝变得好看起来。因为就像她说的，有些东西只有我们两个人知道，而这些"只有我们知道的事"，一点一点地，拼成了属于我们的整个世界。</p>
<p>那晚我们聊到天快亮，最后她靠在我肩上睡着了。窗外的天边泛起了鱼肚白，新的一天开始了。而我们关于"家"的答案，已经找到了。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20bedroom%20at%20night%2C%20two%20figures%20lying%20in%20bed%20facing%20each%20other%2C%20soft%20moonlight%20through%20window%2C%20intimate%20conversation%20atmosphere%2C%20warm%20minimal%20lighting%2C%20cream%20bedding%2C%20peaceful%20and%20tender%20mood%2C%20shadow%20patterns%20on%20ceiling%2C%20artistic%20night%20photography%2C%20emotional%20closeness%20theme&width=800&height=500&seq=article-cover-10&orientation=landscape',
    category: '情感共鸣',
    categorySlug: 'qinggan-gongming',
    author: '念念',
    publishedAt: '2026-07-10',
    readTime: 7,
    tags: ['深夜对话', '家的定义', '亲密', '感悟'],
    featured: false,
  },
  {
    id: 'art-011',
    title: '两个人在一起久了，如何保持新鲜感',
    slug: 'lianggeren-zaijiur-le-baochi-xinxiangan',
    excerpt: '在一起三年后，我们开始面对一个所有情侣都会遇到的问题：新鲜感的消退。但我们找到了一些方法，让爱在日常中重新发光。',
    content: `<p>第三年是我们的"考验期"。不再有刚在一起时的怦然心动，取而代之的是越来越熟悉的日常。她知道我所有的小毛病，我也了解她每一个习惯——这种了解是温暖的，但有时候，也会让人感到一种隐隐的倦怠。</p>
<p>转折点发生在一个普通的周二晚上。她下班回来，没有像往常一样径直去洗澡，而是从背后拿出两件东西——两张陶艺课的体验券。"我们去玩泥巴吧。"她笑着说。</p>
<p>于是我被迫从沙发上爬起来，在她的"胁迫"下去了一家陶艺工作室。结果出人意料地好玩。我们两个笨手笨脚地各自做了一个歪歪扭扭的杯子，她的像碗，我的像花盆，但我们笑到肚子疼。后来那两个"杯子"被我们摆在书架上，每次看到都会笑。</p>
<p>从那天起，我们开始有意识地创造"新鲜感时刻"。每周至少一起尝试一件新的事情——不一定要多隆重，有时候只是一家新开的早餐店，有时候是学一首新的四手联弹，有时候是突发奇想地半夜开车去山顶看日出。</p>
<p>我渐渐明白，新鲜感不是被动等待的东西，它需要主动去创造。而创造新鲜感的过程本身，就是一种新的浪漫。现在我们的关系比以前更好了——不是回到了热恋期，而是找到了比热恋更深的东西。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20women%20making%20pottery%20together%20at%20a%20ceramic%20studio%2C%20hands%20covered%20in%20clay%2C%20laughing%2C%20warm%20natural%20light%20from%20windows%2C%20pottery%20wheels%2C%20creative%20workshop%20atmosphere%2C%20cream%20and%20terracotta%20tones%2C%20happy%20genuine%20expressions%2C%20artistic%20lifestyle%20photography%2C%20fun%20and%20intimate%20moment&width=800&height=500&seq=article-cover-11&orientation=landscape',
    category: '相处之道',
    categorySlug: 'xiangchu-zhidao',
    author: '安安',
    publishedAt: '2026-07-07',
    readTime: 7,
    tags: ['新鲜感', '长期关系', '浪漫', '创造'],
    featured: false,
  },
  {
    id: 'art-012',
    title: '她的三十岁生日：我准备的惊喜',
    slug: 'ta-sanshisui-shengri-jingxi',
    excerpt: '她三字头的第一天，我想给她一个特别的生日。从手写信到翻唱歌曲，也许不是最豪华的，但一定是最用心的。',
    content: `<p>她的三十岁生日，我提前三个月就开始准备了。不是因为她要求什么，而是因为我想告诉她：你的每一个里程碑，我都想认真对待。</p>
<p>我没有选择买很贵的礼物——我们都不是物质的人。我决定做三件事。</p>
<p>第一件是一封信。真正的手写信，写在那种有暗纹的信纸上。我写了她的三十个优点，从"你煎的蛋永远是我吃过最好吃的"到"你在人多的时候会下意识地找我，这个习惯让我觉得自己很重要"。写的过程中我哭了好几次，因为写着写着才发现，原来她在我心里占据了这么多。</p>
<p>第二件是我偷偷学了一首她最喜欢的歌——《小幸运》。我唱歌不好听，但我找了朋友帮忙，录了一个简单的吉他伴奏版。录了好几遍才勉强满意，每一遍都饱含着我笨拙但真诚的心意。</p>
<p>第三件是我给她做了一顿晚饭。不是什么大餐，全是我学会做的她爱吃的菜——糖醋排骨、蒜蓉西兰花、还有她最爱的番茄蛋汤。我把家里布置了一下，点了蜡烛，放了音乐，安安静静地等她下班回来。</p>
<p>她进门看到这一切的时候愣住了，然后眼眶就红了。"三十岁了，有什么感想？"我问她。她走过来抱住我，声音有点哽咽："三十岁最好的礼物，是身边有你。"</p>
<p>那一刻，我觉得所有的准备都值了。原来最打动人的，从来不是多贵的东西，而是你为一个人花的时间、心意和那些笨拙却真挚的努力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20candlelit%20dinner%20table%20set%20for%20two%20in%20a%20cozy%20home%2C%20flowers%20and%20handwritten%20letter%20on%20table%2C%20warm%20candle%20glow%2C%20intimate%20birthday%20celebration%2C%20cream%20and%20soft%20gold%20tones%2C%20feminine%20table%20setting%2C%20thoughtful%20surprise%20atmosphere%2C%20warm%20evening%20light%2C%20artistic%20interior%20photography%2C%20love%20and%20care%20theme&width=800&height=500&seq=article-cover-12&orientation=landscape',
    category: '日常生活',
    categorySlug: 'richang-shenghuo',
    author: '小鹿',
    publishedAt: '2026-07-04',
    readTime: 8,
    tags: ['生日', '惊喜', '礼物', '用心'],
    featured: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
};